/* eslint-disable no-useless-escape */
/* eslint-disable array-callback-return */
import React from "react";
import SimpleCrypto from "simple-crypto-js";
import fileExtension from "file-extension";
import { notification, Icon, Button } from "antd";
import { Router, Link } from "react-router-dom";
import store from "../store";
import packageJson from "../../package.json";
import history from "../History";
import moment from "moment";
import message_notification from "../assets/sounds/message_notification.mp3";

const CRYPTO_KEY = "Bunkey__TI__2019";
const LINK_COLOR =
  store !== undefined &&
    store.getState().authUser.user &&
    store.getState().authUser.user.color
    ? store.getState().authUser.user.color
    : "#2E97CF";

export const VERSION = packageJson.version;
export const KEY_CODE_ESC = 27;
export const KEY_CODE_LEFT = 37;
export const KEY_CODE_RIGHT = 39;
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_TAB = 9;
export const KEY_CODE_ARROBA = 50;
export const MAX_PAG_SIZE = 20;
export const KEY_CODE_DELETE = 8;
export const KEY_CODE_COMA = 188;
export const JOBS_INIT = 1;
export const JOBS_COMPLETE = 2;
export const JOBS_SUCCESS = 3;
export const JOBS_FAILURE = 4;
export const CREATE_GROUP = "CREATE_GROUP";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const ADD_OBJECT_GROUP = "ADD_OBJECT_GROUP";
export const REMOVE_OBJECT_GROUP = "REMOVE_OBJECT_GROUP";
export const NOTIFICATION_INTERVAL_TIME = 15000;
export const ENDPOINT = process.env.REACT_APP_BUNKEY_API;
export const USER_NOT_FOUND_RECOVERY = 502;
export const USER_DISABLED = 403;
export const USER_LOGIN_ATTEMPS_DISABLED = 3;
export const USER_LOGIN_TIME_ATTEMPS_DISABLED = 30;
export const USER_LOGIN_ATTEMPS_DISABLED_CODE = "MaxLoginAttemps";

// Tamano de pagina de la papelera. El listado se pagina en el servidor: traerla
// completa costaba varios MB por request en clientes con miles de elementos.
export const TRASH_PAGE_SIZE = 50;
export const USER_DISABLED_CODE = "PeriodCredentialNotValid";
export const USER_INACTIVE = 403;
export const USER_INACTIVE_CODE = "InactiveUser";
export const NOT_FOUND_STATUS = 404;
export const UNAUTHORIZED_ERROR = 403;
export const MAX_WIDTH = 992;
export const COOKIE_MFA = "_bkzq";
// export const MAX_SIZE_DOWNLOAD_ZIP_FOLDER = 500000000 // 500 MB
export const MAX_SIZE_DOWNLOAD_ZIP_FOLDER = 50000000; // 50 MB

// refresh token modal constants
export const MILLISECONDS_SHOW_IDLE_USER = 1800000;
export const SECONDS_DESTROY_SESSION = 60;

// for dart carrousel
export const PAGINATION_SIZE = 5;

export const PROD_CLIENT_IAB_COLOMBIA = "5f5938e31d8cd80d681b673a";
export const LIMIT_ROWS_EOS_REPORT = 6000;
export const PERMISSION_KEY_SUFFIX = "_permission";

export const SHOW_ONLY_MY_BUNKERS = [
  "5f3ed8181d8cd80d681b6734",
  "5f4059081d8cd80d681b6738", // Effie College Escudo 2020
  "5f4058f11d8cd80d681b6737", // Effie College Easy 2020
  "5f4058dc1d8cd80d681b6736", // Effie College Claro 2020
  "5f4058b11d8cd80d681b6735" // Effie College BCH 2020
];

export const AUDIO_EXT = ["mp3", "wav", "ogg", "3gp", "adts", "flac", "aiff"];
export const IMAGE_EXT = ["bmp", "cpt", "dds", "dib", "dng", "emf", "gif", "heic", "ico", "icon", "jpeg", "jpg", "pcx", "pic", "png", "psd", "psdx", "raw", "tga", "thm", "tif", "tiff", "wbmp", "wdp", "webp", "arw", "cr2", "ai", "cdr", "csh", "csl", "drw", "emz", "odg", "pic", "sda", "svg", "svgz", "swf", "wmf", "abr", "aep", "ai", "ani", "cdt", "djvu", "eps", "fla", "icns", "ico", "icon", "mdi", "odg", "pic", "psb", "psd", "pzl", "sup", "vsdx", "xmp", "3d", "3ds", "c4d", "dgn", "dwfx", "dwg", "dxf", "ipt", "lcf", "max", "obj", "pro", "skp", "stl", "u3d", "x_t"];

export const getWithDrawer = () => {
  return store.getState().app.width <= 500
    ? store.getState().app.width - 20
    : 500;
};

export const getLastcommentsDrawerWitdh = () => {
  return store.getState().app.width <= 500
    ? store.getState().app.width - 20
    : store.getState().app.width * 0.38;
};

export const randomString = () => {
  return Math.random()
    .toString(36)
    .substring(3);
};

export const isEmail = (email = null) => {
  const re = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return re.test(String(email).toLowerCase());
};

export const isCellphone = number => {
  const re = /^[\(]?[\+]?(\d{2}|\d{3})[\)]?[\s]?((\d{6}|\d{8})|(\d{3}[\*\.\-\s]){2}\d{3}|(\d{2}[\*\.\-\s]){3}\d{2}|(\d{4}[\*\.\-\s]){1}\d{4})|\d{8}|\d{10}|\d{12}$/; // eslint-disable-line
  return re.test(number);
};

export const isText = text => {
  const re = /^[a-zA-Z ]{2,254}$/; // eslint-disable-line
  return re.test(text);
};

export const randomNumber = (type, min, max) => {
  return type === "entero"
    ? Math.floor(Math.random() * (max - min)) + min
    : Math.random() * (max - min) + min;
};

const dartPermissionRe = /\w+Dart/;
const folderPermissionRe = /\w+Folder/;
const hostPermissionRe = /\w+Host/;
export const isDartPermission = permission => {
  return dartPermissionRe.test(permission);
};

export const isFolderPermission = permission => {
  return folderPermissionRe.test(permission);
};

export const isAssetPermission = permission => {
  return !(
    folderPermissionRe.test(permission) || dartPermissionRe.test(permission)
  );
};

export const isHostPermission = permission => hostPermissionRe.test(permission);

export const toTitleCase = s =>
  s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase();

export const getAssetType = value => {
  let ext = "";
  switch (value) {
    case "image/png":
      ext = "png";

      break;
    case "video/mp4":
      ext = "mp4";

      break;
    case "image/jpeg":
      ext = "jpg";

      break;

    default:
      console.log("ext catch", value);

      break;
  }

  return ext;
};

export const encrypt = txt => {
  const sc = new SimpleCrypto(CRYPTO_KEY);
  return sc.encrypt(txt);
};

export const decrypt = txt => {
  if (!txt) return null;
  const sc = new SimpleCrypto(CRYPTO_KEY);
  return sc.decrypt(txt);
};

export const localGet = key => {
  if (process.env.NODE_ENV === "production") {
    return decrypt(localStorage.getItem(btoa(key)));
  } else {
    return localStorage.getItem(key);
  }
};

export const localRemove = key => {
  if (process.env.NODE_ENV === "production") {
    return localStorage.removeItem(btoa(key));
  } else {
    return localStorage.removeItem(key);
  }
};

export const getBreadCrumbs = folderselect => {
  const breadcrumbs = store.getState().client.breadcrumb;
  if (!breadcrumbs || !folderselect) return [];

  let item = breadcrumbs.find(r => r._id === folderselect);
  if (item) {
    return [
      ...item.parents.map(r => {
        return {
          id: r._id,
          name: r.name.toLowerCase() === "home" ? "Bunkers" : r.name
        };
      }),
      {
        id: folderselect,
        name: item.name
      }
    ];
  } else {
    return [
      {
        id: folderselect,
        name: "Home"
      }
    ];
  }
};

export const getImageAssettByExtension = src => {
  let ext = fileExtension(src);
  const video_extensions = [
    "264",
    "3g2",
    "3gp",
    "arf",
    "asf",
    "asx",
    "avi",
    "bik",
    "dash",
    "dat",
    "dvr",
    "flv",
    "h264",
    "m2t",
    "m2ts",
    "m4v",
    "mkv",
    "mod",
    "mov",
    "mp4",
    "mpeg",
    "mpg",
    "mts",
    "ogv",
    "prproj",
    "rec",
    "rmvb",
    "swf",
    "tod",
    "tp",
    "ts",
    "vob",
    "webm",
    "wlmp",
    "wmv"
  ];
  const audio_extensions = [
    "3ga",
    "aac",
    "aiff",
    "amr",
    "ape",
    "arf",
    "asf",
    "asx",
    "cda",
    "dvf",
    "flac",
    "gp4",
    "gp5",
    "gpx",
    "logic",
    "m4a",
    "m4b",
    "m4p",
    "midi",
    "mp3",
    "ogg",
    "opus",
    "pcm",
    "rec",
    "snd",
    "sng",
    "uax",
    "wav",
    "wma",
    "wpl",
    "zab"
  ];
  const image_extensions = [
    "bmp",
    "cpt",
    "dds",
    "dib",
    "dng",
    "emf",
    "gif",
    "heic",
    "ico",
    "icon",
    "jpeg",
    "jpg",
    "pcx",
    "pic",
    "png",
    "psd",
    "psdx",
    "raw",
    "tga",
    "thm",
    "tif",
    "tiff",
    "wbmp",
    "wdp",
    "webp",
    "arw",
    "cr2",
    "crw",
    "dcr",
    "dng",
    "fpx",
    "mrw",
    "nef",
    "orf",
    "pcd",
    "ptx",
    "raf",
    "raw",
    "rw2",
    "ai",
    "cdr",
    "csh",
    "csl",
    "drw",
    "emz",
    "odg",
    "pic",
    "sda",
    "svg",
    "svgz",
    "swf",
    "wmf",
    "abr",
    "aep",
    "ai",
    "ani",
    "cdt",
    "djvu",
    "eps",
    "fla",
    "icns",
    "ico",
    "icon",
    "mdi",
    "odg",
    "pic",
    "psb",
    "psd",
    "pzl",
    "sup",
    "vsdx",
    "xmp",
    "3d",
    "3ds",
    "c4d",
    "dgn",
    "dwfx",
    "dwg",
    "dxf",
    "ipt",
    "lcf",
    "max",
    "obj",
    "pro",
    "skp",
    "stl",
    "u3d",
    "x_t"
  ];
  const font_extensions = ["eot", "otf", "ttc", "ttf", "woff"];
  const document_extensions = [
    "abw",
    "aww",
    "chm",
    "cnt",
    "dbx",
    "djvu",
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "epub",
    "gp4",
    "ind",
    "indd",
    "key",
    "keynote",
    "mht",
    "mpp",
    "odf",
    "ods",
    "odt",
    "opx",
    "ott",
    "oxps",
    "pages",
    "pdf",
    "pmd",
    "pot",
    "potx",
    "pps",
    "ppsx",
    "ppt",
    "pptm",
    "pptx",
    "prn",
    "prproj",
    "ps",
    "pub",
    "pwi",
    "rtf",
    "sdd",
    "sdw",
    "shs",
    "snp",
    "sxw",
    "tpl",
    "vsd",
    "wpd",
    "wps",
    "wri",
    "xps",
    "1st",
    "alx",
    "application",
    "asp",
    "csv",
    "htm",
    "html",
    "log",
    "lrc",
    "lst",
    "md",
    "nfo",
    "opml",
    "plist",
    "reg",
    "rtf",
    "srt",
    "sub",
    "tbl",
    "text",
    "txt",
    "xml",
    "xmp",
    "xsd",
    "xsl",
    "xslt",
    "azw",
    "azw3",
    "azw4",
    "cbr",
    "cbz",
    "epub",
    "fb2",
    "iba",
    "ibooks",
    "lit",
    "mobi",
    "pdf",
    "numbers",
    "ods",
    "sdc",
    "sxc",
    "xls",
    "xlsm",
    "xlsx",
    "accdt",
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "mdb",
    "mpd",
    "mpp",
    "mpt",
    "oft",
    "one",
    "onepkg",
    "pot",
    "potx",
    "pps",
    "ppsx",
    "ppt",
    "pptm",
    "pptx",
    "pst",
    "pub",
    "snp",
    "thmx",
    "vsd",
    "vsdx",
    "xls",
    "xlsm",
    "xlsx"
  ];
  const archives_extensions = [
    "001",
    "002",
    "003",
    "004",
    "005",
    "006",
    "007",
    "008",
    "009",
    "010",
    "7z",
    "7z.001",
    "7z.002",
    "7z.003",
    "7z.004",
    "7zip",
    "a00",
    "a01",
    "a02",
    "a03",
    "a04",
    "a05",
    "ace",
    "air",
    "appxbundle",
    "arc",
    "arj",
    "asec",
    "bar",
    "bin",
    "c00",
    "c01",
    "c02",
    "c03",
    "cab",
    "cbr",
    "cbz",
    "cso",
    "deb",
    "dlc",
    "gz",
    "gzip",
    "hqx",
    "inv",
    "ipa",
    "isz",
    "jar",
    "msu",
    "nbh",
    "pak",
    "part1.exe",
    "part1.rar",
    "part2.rar",
    "pkg",
    "pkg",
    "r00",
    "r01",
    "r02",
    "r03",
    "r04",
    "r05",
    "r06",
    "r07",
    "r08",
    "r09",
    "r10",
    "rar",
    "rpm",
    "sis",
    "sisx",
    "sit",
    "sitd",
    "sitx",
    "tar",
    "tar.gz",
    "tgz",
    "uax",
    "vsix",
    "webarchive",
    "xap",
    "z01",
    "z02",
    "z03",
    "z04",
    "z05",
    "zab",
    "zip",
    "zipx"
  ];

  const found_ext_audio = audio_extensions.find(r => r === ext);
  const found_ext_archives = archives_extensions.find(r => r === ext);
  const found_ext_font = font_extensions.find(r => r === ext);
  const found_ext_video = video_extensions.find(r => r === ext);
  const found_ext_document = document_extensions.find(r => r === ext);
  const found_ext_image = image_extensions.find(r => r === ext);

  var found_ext = null;
  if (found_ext_audio) {
    found_ext = "audio";
    return `/images/extensions/${found_ext}.png`;
  } else if (found_ext_archives) {
    found_ext = "archives";
    return `/images/extensions/${found_ext}.png`;
  } else if (found_ext_font) {
    found_ext = "font";
    return `/images/extensions/${found_ext}.png`;
  } else if (found_ext_video) {
    found_ext = "video";
    return `/images/extensions/${found_ext}.png`;
  } else if (found_ext_document) {
    found_ext = "document";
    return `/images/extensions/${found_ext}.png`;
  } else if (found_ext_image) {
    const image_extensions_ok = [
      "jpeg",
      "jpg",
      "gif ",
      "bmp",
      "wbmp",
      "webp",
      "gif",
      "png"
    ];
    var foundformat = image_extensions_ok.find(r => r === ext);
    if (foundformat) {
      return src
    } else {
      found_ext = "image";
      return `/images/extensions/${found_ext}.png`;
    }
  } else {
    return src;
  }
  // const extensions = [
  //   "aif",
  //   "tif",
  //   "tiff",
  //   "raw",
  //   "psd",
  //   "ps",
  //   "ppt",
  //   "pptx",
  //   "iso",
  //   "indd",
  //   "fla",
  //   "eps",
  //   "dmg",
  //   "cad",
  //   "bmp",
  //   "ai",
  //   "cr2",
  //   "arw",
  // ];
  // const found = extensions.find((r) => r === ext);
  // if (found) return `/images/extensions/${ext}.png`;
  // else return src;
};

export const getImageDocumentByExtension = (src, item) => {
  let ext = fileExtension(src);
  // const extensions = ["aep", "nef", "aif", "rar", "tga", "dpx", "zip", "xml", "xls", "xlsx", "wmv", "txt", "tif", "sql",
  //   "raw", "psd", "ps", "ppt", "pptx", "png", "php", "pdf", "mpg", "mp3", "mov", "midi", "js", "jpg",
  //   "iso", "indd", "html", "gif", "flv", "fla", "eps", "doc", "docx", "dmg", "dll", "dat", "css", "cad", "bmp", "ai", "wav", "cr2",
  //   "otf", "mxf", "arw"]

  const video_extensions = [
    "264",
    "3g2",
    "3gp",
    "arf",
    "asf",
    "asx",
    "avi",
    "bik",
    "dash",
    "dat",
    "dvr",
    "flv",
    "h264",
    "m2t",
    "m2ts",
    "m4v",
    "mkv",
    "mod",
    "mov",
    "mp4",
    "mpeg",
    "mpg",
    "mts",
    "ogv",
    "prproj",
    "rec",
    "rmvb",
    "swf",
    "tod",
    "tp",
    "ts",
    "vob",
    "webm",
    "wlmp",
    "wmv"
  ];
  const audio_extensions = [
    "3ga",
    "aac",
    "aiff",
    "amr",
    "ape",
    "arf",
    "asf",
    "asx",
    "cda",
    "dvf",
    "flac",
    "gp4",
    "gp5",
    "gpx",
    "logic",
    "m4a",
    "m4b",
    "m4p",
    "midi",
    "mp3",
    "ogg",
    "opus",
    "pcm",
    "rec",
    "snd",
    "sng",
    "uax",
    "wav",
    "wma",
    "wpl",
    "zab"
  ];
  const image_extensions = [
    "bmp",
    "cpt",
    "dds",
    "dib",
    "dng",
    "emf",
    "gif",
    "heic",
    "ico",
    "icon",
    "jpeg",
    "jpg",
    "pcx",
    "pic",
    "png",
    "psd",
    "psdx",
    "raw",
    "tga",
    "thm",
    "tif",
    "tiff",
    "wbmp",
    "wdp",
    "webp",
    "arw",
    "cr2",
    "crw",
    "dcr",
    "dng",
    "fpx",
    "mrw",
    "nef",
    "orf",
    "pcd",
    "ptx",
    "raf",
    "raw",
    "rw2",
    "ai",
    "cdr",
    "csh",
    "csl",
    "drw",
    "emz",
    "odg",
    "pic",
    "sda",
    "svg",
    "svgz",
    "swf",
    "wmf",
    "abr",
    "aep",
    "ai",
    "ani",
    "cdt",
    "djvu",
    "eps",
    "fla",
    "icns",
    "ico",
    "icon",
    "mdi",
    "odg",
    "pic",
    "psb",
    "psd",
    "pzl",
    "sup",
    "vsdx",
    "xmp",
    "3d",
    "3ds",
    "c4d",
    "dgn",
    "dwfx",
    "dwg",
    "dxf",
    "ipt",
    "lcf",
    "max",
    "obj",
    "pro",
    "skp",
    "stl",
    "u3d",
    "x_t"
  ];
  const font_extensions = ["eot", "otf", "ttc", "ttf", "woff"];
  const document_extensions = [
    "abw",
    "aww",
    "chm",
    "cnt",
    "dbx",
    "djvu",
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "epub",
    "gp4",
    "ind",
    "indd",
    "key",
    "keynote",
    "mht",
    "mpp",
    "odf",
    "ods",
    "odt",
    "opx",
    "ott",
    "oxps",
    "pages",
    "pdf",
    "pmd",
    "pot",
    "potx",
    "pps",
    "ppsx",
    "ppt",
    "pptm",
    "pptx",
    "prn",
    "prproj",
    "ps",
    "pub",
    "pwi",
    "rtf",
    "sdd",
    "sdw",
    "shs",
    "snp",
    "sxw",
    "tpl",
    "vsd",
    "wpd",
    "wps",
    "wri",
    "xps",
    "1st",
    "alx",
    "application",
    "asp",
    "csv",
    "htm",
    "html",
    "log",
    "lrc",
    "lst",
    "md",
    "nfo",
    "opml",
    "plist",
    "reg",
    "rtf",
    "srt",
    "sub",
    "tbl",
    "text",
    "txt",
    "xml",
    "xmp",
    "xsd",
    "xsl",
    "xslt",
    "azw",
    "azw3",
    "azw4",
    "cbr",
    "cbz",
    "epub",
    "fb2",
    "iba",
    "ibooks",
    "lit",
    "mobi",
    "pdf",
    "numbers",
    "ods",
    "sdc",
    "sxc",
    "xls",
    "xlsm",
    "xlsx",
    "accdt",
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "mdb",
    "mpd",
    "mpp",
    "mpt",
    "oft",
    "one",
    "onepkg",
    "pot",
    "potx",
    "pps",
    "ppsx",
    "ppt",
    "pptm",
    "pptx",
    "pst",
    "pub",
    "snp",
    "thmx",
    "vsd",
    "vsdx",
    "xls",
    "xlsm",
    "xlsx"
  ];
  const archives_extensions = [
    "001",
    "002",
    "003",
    "004",
    "005",
    "006",
    "007",
    "008",
    "009",
    "010",
    "7z",
    "7z.001",
    "7z.002",
    "7z.003",
    "7z.004",
    "7zip",
    "a00",
    "a01",
    "a02",
    "a03",
    "a04",
    "a05",
    "ace",
    "air",
    "appxbundle",
    "arc",
    "arj",
    "asec",
    "bar",
    "bin",
    "c00",
    "c01",
    "c02",
    "c03",
    "cab",
    "cbr",
    "cbz",
    "cso",
    "deb",
    "dlc",
    "gz",
    "gzip",
    "hqx",
    "inv",
    "ipa",
    "isz",
    "jar",
    "msu",
    "nbh",
    "pak",
    "part1.exe",
    "part1.rar",
    "part2.rar",
    "pkg",
    "pkg",
    "r00",
    "r01",
    "r02",
    "r03",
    "r04",
    "r05",
    "r06",
    "r07",
    "r08",
    "r09",
    "r10",
    "rar",
    "rpm",
    "sis",
    "sisx",
    "sit",
    "sitd",
    "sitx",
    "tar",
    "tar.gz",
    "tgz",
    "uax",
    "vsix",
    "webarchive",
    "xap",
    "z01",
    "z02",
    "z03",
    "z04",
    "z05",
    "zab",
    "zip",
    "zipx"
  ];

  var found_ext = null;
  if (item && item.type) {
    switch (item.type) {
      case "audio":
        found_ext = audio_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = "audio";
        }
        break;
      case "other":
        found_ext = archives_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = "archives";
        }
        break;
      case "font":
        found_ext = font_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = "font";
        }
        break;
      case "video":
        found_ext = video_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = "video";
        }
        break;
      case "document":
        found_ext = document_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = "document";
        } else {
          const found_audio = audio_extensions.find(r => r === ext);
          if (found_audio) {
            found_ext = "audio";
          } else {
            const found_other = archives_extensions.find(r => r === ext);
            if (found_other) {
              found_ext = "archives";
            } else {
              const found_font = font_extensions.find(r => r === ext);
              if (found_font) {
                found_ext = "font";
              } else {
                const found_video = video_extensions.find(r => r === ext);
                if (found_video) {
                  found_ext = "video";
                } else {
                  const found_image = image_extensions.find(r => r === ext);
                  if (found_image) {
                    found_ext = "image";
                  }
                }
              }
            }
          }
        }
        break;
      case "image":
        found_ext = image_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = "image";
        }
        break;
      default:
        break;
    }
  }

  // const found = extensions.find(r => r === ext)

  if (found_ext) return `/images/extensions/${found_ext}.png`;
  else return `/images/extensions/file.png`;
};

export const extValidateDownload = (src, item) => {
  let ext = fileExtension(src);

  const video_extensions = [
    "264",
    "3g2",
    "3gp",
    "arf",
    "asf",
    "asx",
    "avi",
    "bik",
    "dash",
    "dat",
    "dvr",
    "flv",
    "h264",
    "m2t",
    "m2ts",
    "m4v",
    "mkv",
    "mod",
    "mov",
    "mp4",
    "mpeg",
    "mpg",
    "mts",
    "ogv",
    "prproj",
    "rec",
    "rmvb",
    "swf",
    "tod",
    "tp",
    "ts",
    "vob",
    "webm",
    "wlmp",
    "wmv"
  ];
  // const audio_extensions = ["3ga","aac","aiff","amr","ape","arf","asf","asx","cda","dvf","flac","gp4","gp5","gpx","logic","m4a","m4b","m4p","midi","mp3","ogg","opus","pcm","rec","snd","sng","uax","wav","wma","wpl","zab"]
  const image_extensions = [
    "bmp",
    "cpt",
    "dds",
    "dib",
    "dng",
    "emf",
    "gif",
    "heic",
    "ico",
    "icon",
    "jpeg",
    "jpg",
    "pcx",
    "pic",
    "png",
    "psd",
    "psdx",
    "raw",
    "tga",
    "thm",
    "tif",
    "tiff",
    "wbmp",
    "wdp",
    "webp",
    "arw",
    "cr2",
    "crw",
    "dcr",
    "dng",
    "fpx",
    "mrw",
    "nef",
    "orf",
    "pcd",
    "ptx",
    "raf",
    "raw",
    "rw2",
    "ai",
    "cdr",
    "csh",
    "csl",
    "drw",
    "emz",
    "odg",
    "pic",
    "sda",
    "svg",
    "svgz",
    "swf",
    "wmf",
    "abr",
    "aep",
    "ai",
    "ani",
    "cdt",
    "djvu",
    "eps",
    "fla",
    "icns",
    "ico",
    "icon",
    "mdi",
    "odg",
    "pic",
    "psb",
    "psd",
    "pzl",
    "sup",
    "vsdx",
    "xmp",
    "3d",
    "3ds",
    "c4d",
    "dgn",
    "dwfx",
    "dwg",
    "dxf",
    "ipt",
    "lcf",
    "max",
    "obj",
    "pro",
    "skp",
    "stl",
    "u3d",
    "x_t"
  ];
  // const font_extensions = ["eot","otf","ttc","ttf","woff"]
  // const document_extensions = ["abw","aww","chm","cnt","dbx","djvu","doc","docm","docx","dot","dotm","dotx","epub","gp4","ind","indd","key","keynote","mht","mpp","odf","ods","odt","opx","ott","oxps","pages","pdf","pmd","pot","potx","pps","ppsx","ppt","pptm","pptx","prn","prproj","ps","pub","pwi","rtf","sdd","sdw","shs","snp","sxw","tpl","vsd","wpd","wps","wri","xps","1st","alx","application","asp","csv","htm","html","log","lrc","lst","md","nfo","opml","plist","reg","rtf","srt","sub","tbl","text","txt","xml","xmp","xsd","xsl","xslt","azw","azw3","azw4","cbr","cbz","epub","fb2","iba","ibooks","lit","mobi","pdf","numbers","ods","sdc","sxc","xls","xlsm","xlsx","accdt","doc","docm","docx","dot","dotm","dotx","mdb","mpd","mpp","mpt","oft","one","onepkg","pot","potx","pps","ppsx","ppt","pptm","pptx","pst","pub","snp","thmx","vsd","vsdx","xls","xlsm","xlsx"]
  // const archives_extensions = ["001","002","003","004","005","006","007","008","009","010","7z","7z.001","7z.002","7z.003","7z.004","7zip","a00","a01","a02","a03","a04","a05","ace","air","appxbundle","arc","arj","asec","bar","bin","c00","c01","c02","c03","cab","cbr","cbz","cso","deb","dlc","gz","gzip","hqx","inv","ipa","isz","jar","msu","nbh","pak","part1.exe","part1.rar","part2.rar","pkg","pkg","r00","r01","r02","r03","r04","r05","r06","r07","r08","r09","r10","rar","rpm","sis","sisx","sit","sitd","sitx","tar","tar.gz","tgz","uax","vsix","webarchive","xap","z01","z02","z03","z04","z05","zab","zip","zipx",]

  var found_ext = false;
  if (item && item.type) {
    switch (item.type) {
      case "video":
        found_ext = video_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = true;
        }
        break;
      case "image":
        found_ext = image_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = true;
        }
        break;
      case "document":
        found_ext = video_extensions.find(r => r === ext);
        if (found_ext) {
          found_ext = true;
        } else {
          found_ext = image_extensions.find(r => r === ext);
          if (found_ext) {
            found_ext = true;
          }
        }
        break;
      default:
        break;
    }
  }
  return found_ext ? true : false;
};

export const validateImageSpecialExtensions = src => {
  let ext = fileExtension(src);
  const extensions = ["cr2"];
  const found = extensions.find(r => r === ext);

  if (found) return true;
  else return false;
};

export const extensionValidateDownload = src => {
  let typeExtensions = fileExtension(src);
  const extensionsValidate = [
    "rar",
    "pdf",
    "doc",
    "ppt",
    "wav",
    "xls",
    "zip",
    "odt",
    "log",
    "txt",
    "docx",
    "tar",
    "xls",
    "xml",
    "arj",
    "iso",
    "ai",
    "exe",
    "eps",
    "ait",
    "svgz",
    "svg",
    "mp3",
    "cr2"
  ];
  const foundExtensions = extensionsValidate.find(r => r === typeExtensions);
  return foundExtensions ? true : false;
};

export const validateEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhoneNumber = phoneNumber => {
  // define a regular expression for the phone number pattern
  const phonePattern = /^\d+$/;

  // test the phone number input against the regular expression
  return phonePattern.test(phoneNumber);
};

export const dontTruncateTitle = (name, src, type) => {
  let ext = fileExtension(src);
  let title = null;

  if (ext) title = `${name}.${ext}`;
  else title = `${name}`;
  return title;
};

export const truncateTitle = (name, src, type) => {
  let ext = fileExtension(src);
  let title = null;
  let truncateName = null;

  if (name.length > 30) {
    truncateName = `${name.substring(0, 30)}..`;
  } else {
    truncateName = name.substring(0, 30);
  }

  if (ext) title = `${truncateName}.${ext}`;
  else title = `${truncateName}`;
  return title;
};

export const validateAdmin = () => {
  const user = store.getState().authUser.user;
  if (user.clientRole === "admin" || user.role === "admin") return true;
};

export const validateComercialTuristik = () => {
  const clientId = store.getState().client.data;
  const user = store.getState().authUser.user;
  const comercialTuristikId = "5d0802c89196852249639c6a";
  if (user.clientRole === "admin" || user.role === "admin") return true;
  else return clientId._id !== comercialTuristikId;
};

export const capitalize = s => {
  return s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase();
};

export const sendNotification = (
  type,
  intl,
  message,
  duration = 3.5,
  placement = "topRight",
  description,
  key,
  btnUserAction
) => {
  const customButtonAction = () => {
    if (key) {
      notification.close(key);
    }
    btnUserAction();
  };
  const button = (
    <Button type="primary" size="small" onClick={customButtonAction}>
      {intl.formatMessage({ id: "accept" })}
    </Button>
  );

  switch (type) {
    case "error":
      notification.error({
        message: "Error",
        description: message,
        icon: <Icon type="frown" style={{ color: "#108ee9" }} />,
        duration,
        placement
      });

      break;
    case "warning":
      notification.warning({
        message: intl.formatMessage({ id: "warning" }),
        description: message,
        icon: <Icon type="exclamation-circle" style={{ color: "#108ee9" }} />,
        duration,
        placement
      });

      break;
    case "success":
      notification.success({
        message: intl.formatMessage({ id: "success" }),
        description: message,
        icon: <Icon type="smile" style={{ color: "#108ee9" }} />,
        duration,
        placement
      });

      break;
    case "info":
      if (description && description !== "")
        notification.info({
          message: message,
          description,
          duration,
          placement,
          icon: <Icon type="info-circle" style={{ color: "#108ee9" }} />
        });
      else
        notification.info({
          message,
          duration,
          placement,
          icon: <Icon type="info-circle" style={{ color: "#108ee9" }} />
        });
      break;
    case "process":
      notification.info({
        message,
        description,
        duration: duration,
        key,
        top: "70px",
        icon: <Icon type="loading" style={{ color: "#108ee9" }} />
      });
      break;

    case "successWithUserAction":
      notification.open({
        message: intl.formatMessage({ id: "success" }),
        description: message,
        icon: <Icon type="smile" style={{ color: "#108ee9" }} />,
        duration,
        key,
        placement,
        btn: button,
        onClose: btnUserAction
      });
      break;

    case "goToMentionComment":
      const goToMentionButton = (
        <Button type="primary" size="small" onClick={btnUserAction}>
          {intl.formatMessage({ id: "goToComment" })}
        </Button>
      );
      notification.open({
        message: message,
        description: description,
        icon: <Icon type="info-circle" style={{ color: "#108ee9" }} />,
        duration,
        key,
        placement,
        btn: goToMentionButton,
        onClose: btnUserAction
      });
      break;

    case "errorWithUserAction":
      notification.open({
        message: "Error",
        description: message,
        icon: <Icon type="frown" style={{ color: "#108ee9" }} />,
        duration,
        key,
        placement,
        btn: button,
        onClose: btnUserAction
      });
      break;

    case "errorWithUserActionWithOutAcceptButton":
      const title = intl.formatMessage({ id: "version_has_changed_title" });
      notification.open({
        message: title,
        description: message,
        icon: <Icon type="frown" style={{ color: "#108ee9" }} />,
        duration,
        key,
        placement,

        onClose: btnUserAction
      });
      break;

    case "inactive":
      notification.success({
        message: intl.formatMessage({ id: "closed_session" }),
        description: message,
        icon: <Icon type="smile" style={{ color: "#108ee9" }} />,
        duration,
        placement
      });

      break;
    default:
      break;
  }
};

export const sendMentionNotification = (
  intl,
  message,
  duration = 99999,
  placement = "topRight",
  description,
  key,
  goToCommentAction,
  ignoreCommentAction
) => {
  const customButtonAction = () => {
    if (key) {
      notification.close(key);
    }
    goToCommentAction();
  };

  const goToMentionButton = (
    <Button type="primary" size="small" onClick={customButtonAction}>
      {intl.formatMessage({ id: "goToComment" })}
    </Button>
  );
  notification.open({
    message: message,
    description: description,
    icon: <Icon type="info-circle" style={{ color: "#108ee9" }} />,
    duration,
    key,
    placement,
    btn: goToMentionButton,
    onClose: ignoreCommentAction
  });
};
/**
 *
 * @param {*} intl
 * @param {*} message
 * @param {*} links
 * @name sendNotificationModified
 */
export const sendNotificationModified = (
  intl,
  message,
  links,
  duration = 3.5
) => {
  notification.warning({
    message: intl.formatMessage({ id: "warning" }),
    description: (
      <Router history={history}>
        <div>
          {message}
          <ul>
            {links.map((l, k) => (
              <li key={k} style={{ marginLeft: "-22px" }}>
                {
                  <Link
                    to={`/home/explore/${l.key}`}
                    key={l.id}
                    style={{ fontSize: 13, cursor: "pointer" }}
                  >
                    {l.name}
                  </Link>
                }
              </li>
            ))}
          </ul>
        </div>
      </Router>
    ),
    icon: <Icon type="exclamation-circle" style={{ color: "#108ee9" }} />,
    duration
  });
};

export const permissionTranslation = (permission, intl) => {
  return intl.formatMessage({ id: `${permission}${PERMISSION_KEY_SUFFIX}` });
};

export const getPermission = (permissions, filter) => {
  return permissions && permissions.length > 0
    ? permissions.find(r => r.action === filter).enabled
    : false;
};

export const getNewPermission = (folderSelect, permissions, filter) => {
  let result = false;
  permissions.forEach(item => {
    if (
      item.objects &&
      item.objects.length > 0 &&
      item.objects.includes(folderSelect)
    ) {
      const foundPermission = item.permissions.find(r => r.action === filter);
      if (foundPermission) result = foundPermission.enabled;
    }
  });
  return result;
};

/**
 * Tipos que son contenedores: se rigen por `deleteFolder`, no por `delete`.
 * `bunker` es el tipo que usa el front para los workspaces.
 */
const FOLDER_TYPES = ["root", "folder", "workspace", "bunker"];

/**
 * Permiso que gobierna el borrado de un asset según su tipo.
 *
 * Existe porque el menú de las vistas de colección consultaba siempre `delete`,
 * incluso sobre carpetas: un grupo con `delete` habilitado y `deleteFolder`
 * deshabilitado igual mostraba la opción de eliminar la carpeta. El backend
 * (utils/DeleteAccessService en bunkey.objects) aplica esta misma regla.
 */
export const getDeletePermissionName = type =>
  FOLDER_TYPES.includes(type) ? "deleteFolder" : "delete";

/**
 * ¿Puede borrarse este asset? Resuelve solo el permiso que corresponde al tipo.
 */
export const canDeleteAsset = (asset, permissions) => {
  if (!asset) return false;
  return getNewPermission(
    asset._id,
    permissions,
    getDeletePermissionName(asset.type)
  );
};

export const checkPermissionsOnAsset = (
  assetId,
  newMatrixPermission,
  permissionsArray
) => {
  if (!Array.isArray(permissionsArray)) return false;

  if (permissionsArray.length === 0) return true;
  return permissionsArray.every(permission =>
    getNewPermission(assetId, newMatrixPermission, permission)
  );
};

export const permissionsDefault = () => {
  const intl = store.getState().intl.locale;

  return [
    {
      action: "upload",
      view: intl === "es" ? "Subir" : "Upload",
      enabled: false
    },
    {
      action: "edit",
      view: intl === "es" ? "Editar" : "Edit",
      enabled: false
    },
    {
      action: "download",
      view: intl === "es" ? "Descargar" : "Download",
      enabled: false
    },
    {
      action: "delete",
      view: intl === "es" ? "Eliminar" : "Delete",
      enabled: false
    },
    {
      action: "share",
      view: intl === "es" ? "Compartir" : "Share",
      enabled: false
    },
    {
      action: "move",
      view: intl === "es" ? "Mover" : "Move",
      enabled: false
    },
    {
      action: "confirm",
      view: intl === "es" ? "Confirmar" : "Confirm",
      enabled: false
    },
    {
      action: "createFolder",
      view: intl === "es" ? "Crear Carpeta" : "Create Folder",
      enabled: false
    },
    {
      action: "deleteFolder",
      view: intl === "es" ? "Eliminar Carpeta" : "Delete Folder",
      enabled: false
    },
    {
      action: "editFolder",
      view: intl === "es" ? "Editar Carpeta" : "Edit Folder",
      enabled: false
    },
    {
      action: "shareFolder",
      view: intl === "es" ? "Compartir Carpeta" : "Share Folder",
      enabled: false
    },
    {
      action: "moveFolder",
      view: intl === "es" ? "Mover Carpeta" : "Move Folder",
      enabled: false
    }
  ];
};

export const localSave = object => {
  if (process.env.NODE_ENV === "production") {
    localStorage.setItem(btoa(object.key), encrypt(object.value));
  } else {
    localStorage.setItem(object.key, object.value);
  }
};

export const mergeArrays = (a, b) => {
  const c = a.concat(b);
  return c.filter((item, pos) => c.indexOf(item) === pos);
};
/**
 * @param {string} text
 * @author Victor Smith
 * @name verifySpecialCharsInSearch
 */
export const verifySpecialCharsInSearch = text => {
  const values = ["&", "%"];
  let result = false;
  values.forEach(r => {
    if (text.indexOf(r) > -1) {
      result = true;
    }
  });
  return result;
};

export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
    /[018]/g,
    c =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16) // eslint-disable-line
  );
};
/**
 *
 * @param {*} str
 * @name normalizeString
 * @author Victor Smith
 */
export const normalizeString = str => {
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
/**
 *
 * @param {*} data
 * @name processDownloadhistory
 * @author Victor Smith
 */
export const processDownloadHistory = data => {
  let build = [];
  data.map((m, i) => {
    if (i === 0) {
      build.push({ date: m.createdAt, typeItem: "date" });
    }
    Object.assign(m, { typeItem: "download" });
    build.push(m);
    if (
      data[i + 1] &&
      moment(data[i].createdAt).format("DD/MM/YYYY") !==
      moment(data[i + 1].createdAt).format("DD/MM/YYYY")
    ) {
      build.push({ date: data[i + 1].createdAt, typeItem: "date" });
    }
  });
  return build;
};
/**
 *
 * @param {*} url
 * @name launchDownload
 * @author Victor Smith
 */
export const launchDownload = urlArray => {
  urlArray.map((r, k) => {
    let index = k + 1;
    if (index > 5) {
      setTimeout(() => {
        createDownloadFrame(r.url, index);
      }, 3000 * index);
    } else {
      createDownloadFrame(r.url, index);
    }
  });
};

export const launchDownloadMultiple = urlArray => {
  createDownloadFrame(urlArray, 1);
};

const createDownloadFrame = (url, index) => {
  let idFromUrl = url.replace(/\?/gi, "");
  idFromUrl = idFromUrl.replace(/\&/gi, "");
  idFromUrl = idFromUrl.replace(/\%/gi, "");
  idFromUrl = idFromUrl.replace(/\+/gi, "");
  idFromUrl = idFromUrl.replace(/\ /gi, "");
  const existDownload = document.getElementById(idFromUrl);
  if (existDownload === null) {
    let downloadFrame = document.createElement("iframe");
    downloadFrame.setAttribute("id", idFromUrl);
    downloadFrame.setAttribute("src", url);
    downloadFrame.setAttribute(
      "style",
      "border: 0; clip: rect(0 0 0 0); height: 1px; margin: -1px; overflow: hidden; padding: 0"
    );
    document.body.appendChild(downloadFrame);
    setTimeout(() => {
      document.body.removeChild(downloadFrame);
    }, 30000 * index);
  }
};

export const handleLinkify = textToCheck => {
  let match = "";
  let splitText = [];
  let startIndex = 0;
  let domainMatch = "";
  let urlLength = 0;
  let abort = false;
  let expression = /(?:^|[^@\.\w-])([a-z0-9]+:\/\/)?(\w(?!ailto:)\w+:\w+@)?([\w.-]+\.[a-z]{2,4})(:[0-9]+)?(\/.*)?(?=$|[^@\.\w-])/gi;
  let topDomains = [
    /\.com/,
    /\.de/,
    /\.org/,
    /\.net/,
    /\.us/,
    /\.co/,
    /\.edu/,
    /\.gov/,
    /\.biz/,
    /\.za/,
    /\.info/,
    /\.cc/,
    /\.ca/,
    /\.cn/,
    /\.fr/,
    /\.ch/,
    /\.au/,
    /\.in/,
    /\.jp/,
    /\.be/,
    /\.it/,
    /\.nl/,
    /\.uk/,
    /\.mx/,
    /\.no/,
    /\.ru/,
    /\.br/,
    /\.se/,
    /\.es/,
    /\.at/,
    /\.dk/,
    /\.eu/,
    /\.il/,
    /\.tv/,
    /\.cl/
  ];
  let regex = new RegExp(expression);

  while ((match = regex.exec(textToCheck)) != null) {
    abort = true;
    for (let i = 0; i < topDomains.length; i++) {
      domainMatch = match[0].match(topDomains[i]);
      if (domainMatch) {
        urlLength = domainMatch[0].length + domainMatch.index;
        if (match[0].length === urlLength) {
          abort = false;
        }
        if (
          match[0].length > urlLength &&
          match[0].substr(urlLength, 1) === "/"
        ) {
          abort = false;
        }
      }
    }

    if (match.index !== 0 && textToCheck[match.index - 1] === "@") {
      abort = true;
    }

    if (
      match.index !== 0 &&
      textToCheck[match.index + match[0].length - 1] === "?"
    ) {
      match[0] = match[0].substr(0, match[0].length - 1);
    }

    splitText.push({
      text: textToCheck.substr(startIndex, match.index - startIndex),
      type: "text"
    });

    if (abort) {
      splitText.push({
        text: textToCheck.substr(match.index, match[0].length),
        type: "text"
      });
    } else {
      splitText.push({
        text: textToCheck.substr(match.index, match[0].length),
        type: "link"
      });
    }
    startIndex = match.index + match[0].length;
  }

  if (startIndex < textToCheck.length) {
    splitText.push({
      text: textToCheck.substr(startIndex),
      type: "text"
    });
  }

  return (
    <React.Fragment>
      {splitText.map((st, index) =>
        st.type === "link" ? (
          <a
            href={st.text}
            target="blank"
            style={{ color: LINK_COLOR }}
            key={index}
          >
            {st.text}
          </a>
        ) : (
          verifyBreakLines(st.text).map(m => m)
        )
      )}
    </React.Fragment>
  );
};

export const playMessageNotification = () => {
  const notificationSound = new Audio(message_notification);
  notificationSound.play();
};

const verifyBreakLines = text => {
  return text.split(/\n/gi).map((s, index) =>
    s === "" ? (
      <br key={index} />
    ) : (
      <span key={`${index}-${text}`}>
        {s}
        <br />
      </span>
    )
  );
};

export const modifyBreadCrumbWithChildren = breadcrumb => {
  try {
    const modifyBreadcrumb = [];
    let fullChilds = [];
    for (let i = 0; i < breadcrumb.length; i++) {
      for (let j = 0; j < breadcrumb.length; j++) {
        if (
          breadcrumb[j].parents.find(
            b => b._id.toString() === breadcrumb[i]._id.toString()
          )
        ) {
          fullChilds = [
            ...fullChilds,
            {
              id: breadcrumb[j]._id,
              name: breadcrumb[j].name
            }
          ];
        }
      }
      modifyBreadcrumb.push({
        ...breadcrumb[i],
        fullChilds: fullChilds.filter(f => f._id !== breadcrumb[i]._id)
      });
      fullChilds = [];
    }
    return modifyBreadcrumb;
  } catch (error) {
    console.log("error", error);
  }
};

export const calculateVersionsQuantity = (versions, actualVersion) => {
  let totalVersions = 0;
  const currentVersion = versions.find(
    version => version.versionNumber === actualVersion.versionNumber
  );
  totalVersions = currentVersion ? versions.length : versions.length + 1;
  return totalVersions;
};

export const isVersionTag = tag => {
  const versionRegex = /^([vV]\.([0-9]+))$/;
  const isDateTag = moment(tag, "DD-MM-YYYY", true).isValid();
  if (isDateTag) return true;

  const isHourTag = moment(tag, "HH:mm:ss", true).isValid();
  if (isHourTag) return true;

  return versionRegex.test(tag);
};

export const isMediaActive = (assetsMedia, clientMedia) => {
  try {
    const index = assetsMedia.findIndex(media => {
      if (clientMedia.defaultMedia) {
        return media.defaultMediaId === clientMedia.defaultMediaId;
      } else {
        return media._id === clientMedia._id;
      }
    });
    return index > -1;
  } catch (error) {
    return false;
  }
};

export const handleFormat = size => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return (
    (size / Math.pow(1024, i)).toFixed(2) * 1 +
    " " +
    ["B", "kB", "MB", "GB", "TB"][i]
  );
};

export const getFileType = asset => {
  if (!asset.type) {
    return "document";
  }

  const arrAssetType = asset.type.split("/");
  if (arrAssetType[0] !== "image" && arrAssetType[0] !== "video") {
    return "document";
  }

  return arrAssetType[0];
};

export const getFileName = file => {
  if (file) {
    const fileInfo = file.name.split(".");
    fileInfo.pop();
    return fileInfo.join(".");
  }
  return "";
};

export const handleSetSrc = r => {
  const { originalURL, mediaQualityURL } = r;

  const itemUrl =
    originalURL !== mediaQualityURL
      ? mediaQualityURL
      : getImageAssettByExtension(r.originalURL);

  return itemUrl;
};

export const isDefaultAssetPath = path => {
  try {
    const defaultAssetPath = /\/images\/extensions\/.+\.png$/;

    return defaultAssetPath.test(path);
  } catch (error) {
    return false;
  }
};

export const ValidateAssetExtensionVideo = src => {
  let ext = fileExtension(src);
  const extensions = [
    "264",
    "3g2",
    "3gp",
    "arf",
    "asf",
    "asx",
    "avi",
    "bik",
    "dash",
    "dat",
    "dvr",
    "flv",
    "h264",
    "m2t",
    "m2ts",
    "m4v",
    "mkv",
    "mod",
    "mov",
    "mp4",
    "mpeg",
    "mpg",
    "mts",
    "ogv",
    "prproj",
    "rec",
    "rmvb",
    "swf",
    "tod",
    "tp",
    "ts",
    "vob",
    "webm",
    "wlmp",
    "wmv"
  ];

  const found = extensions.find(r => r === ext);
  if (!found) {
    return false;
  } else {
    return true;
  }
};

export const ValidateAssetExtensionAudio = src => {
  let ext = fileExtension(src);
  const extensions = [
    "3ga",
    "aac",
    "aiff",
    "amr",
    "ape",
    "arf",
    "asf",
    "asx",
    "cda",
    "dvf",
    "flac",
    "gp4",
    "gp5",
    "gpx",
    "logic",
    "m4a",
    "m4b",
    "m4p",
    "midi",
    "mp3",
    "ogg",
    "opus",
    "pcm",
    "rec",
    "snd",
    "sng",
    "uax",
    "wav",
    "wma",
    "wpl",
    "zab"
  ];

  const found = extensions.find(r => r === ext);
  if (!found) {
    return false;
  } else {
    return true;
  }
};

export const ValidateAssetExtensionImage = src => {
  let ext = fileExtension(src);

  const extensions = [
    "bmp",
    "cpt",
    "dds",
    "dib",
    "dng",
    "emf",
    "gif",
    "heic",
    "ico",
    "icon",
    "jpeg",
    "jpg",
    "pcx",
    "pic",
    "png",
    "psd",
    "psdx",
    "raw",
    "tga",
    "thm",
    "tif",
    "tiff",
    "wbmp",
    "wdp",
    "webp",
    "arw",
    "cr2",
    "crw",
    "dcr",
    "dng",
    "fpx",
    "mrw",
    "nef",
    "orf",
    "pcd",
    "ptx",
    "raf",
    "raw",
    "rw2",
    "ai",
    "cdr",
    "csh",
    "csl",
    "drw",
    "emz",
    "odg",
    "pic",
    "sda",
    "svg",
    "svgz",
    "swf",
    "wmf",
    "abr",
    "aep",
    "ai",
    "ani",
    "cdt",
    "djvu",
    "eps",
    "fla",
    "icns",
    "ico",
    "icon",
    "mdi",
    "odg",
    "pic",
    "psb",
    "psd",
    "pzl",
    "sup",
    "vsdx",
    "xmp",
    "3d",
    "3ds",
    "c4d",
    "dgn",
    "dwfx",
    "dwg",
    "dxf",
    "ipt",
    "lcf",
    "max",
    "obj",
    "pro",
    "skp",
    "stl",
    "u3d",
    "x_t"
  ];

  const found = extensions.find(r => r === ext);
  if (!found) {
    return false;
  } else {
    return true;
  }
};

export const ValidateAssetExtensionFonts = src => {
  let ext = fileExtension(src);
  const extensions = ["eot", "otf", "ttc", "ttf", "woff"];

  const found = extensions.find(r => r === ext);
  if (!found) {
    return false;
  } else {
    return true;
  }
};

export const ValidateAssetExtensionDocuments = src => {
  let ext = fileExtension(src);
  const extensions = [
    "abw",
    "aww",
    "chm",
    "cnt",
    "dbx",
    "djvu",
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "epub",
    "gp4",
    "ind",
    "indd",
    "key",
    "keynote",
    "mht",
    "mpp",
    "odf",
    "ods",
    "odt",
    "opx",
    "ott",
    "oxps",
    "pages",
    "pdf",
    "pmd",
    "pot",
    "potx",
    "pps",
    "ppsx",
    "ppt",
    "pptm",
    "pptx",
    "prn",
    "prproj",
    "ps",
    "pub",
    "pwi",
    "rtf",
    "sdd",
    "sdw",
    "shs",
    "snp",
    "sxw",
    "tpl",
    "vsd",
    "wpd",
    "wps",
    "wri",
    "xps",
    "1st",
    "alx",
    "application",
    "asp",
    "csv",
    "htm",
    "html",
    "log",
    "lrc",
    "lst",
    "md",
    "nfo",
    "opml",
    "plist",
    "reg",
    "rtf",
    "srt",
    "sub",
    "tbl",
    "text",
    "txt",
    "xml",
    "xmp",
    "xsd",
    "xsl",
    "xslt",
    "azw",
    "azw3",
    "azw4",
    "cbr",
    "cbz",
    "epub",
    "fb2",
    "iba",
    "ibooks",
    "lit",
    "mobi",
    "pdf",
    "numbers",
    "ods",
    "sdc",
    "sxc",
    "xls",
    "xlsm",
    "xlsx",
    "accdt",
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "mdb",
    "mpd",
    "mpp",
    "mpt",
    "oft",
    "one",
    "onepkg",
    "pot",
    "potx",
    "pps",
    "ppsx",
    "ppt",
    "pptm",
    "pptx",
    "pst",
    "pub",
    "snp",
    "thmx",
    "vsd",
    "vsdx",
    "xls",
    "xlsm",
    "xlsx"
  ];

  const found = extensions.find(r => r === ext);
  if (!found) {
    return false;
  } else {
    return true;
  }
};

export const getFileExtension = fileName => {
  const parts = fileName.split(".");
  if (parts.length === 1 || (parts[0] === "" && parts.length === 2)) {
    return ""; // No file extension found
  }
  return parts[parts.length - 1].toLowerCase();
};

export const getCustomsClients = () => {

  const mamut = {
    name: "MAMUT",
    imgSelector: "/gnbrands/gn-mamut-2.jpg",
    color: "#512C1D",
    cssUploadBanner: "custom-dragzone-mamut",
    navbarLogo: "/gnbrands/navbar-mamut.png",
    footer: [{
      ico: 'instagram',
      label: 'Mamut CL',
      url: 'https://www.instagram.com/mamutrestaurant/'
    }, {
      ico: 'facebook',
      label: 'Mamut CL',
      url: 'https://web.facebook.com/MamutRestaurant'
    }]
  }

  const juanMaestro = {
    name: "JUAN_MAESTRO",
    imgSelector: "/gnbrands/gn-juan-maestro-2.jpg",
    color: "#2E2A25",
    cssUploadBanner: "custom-dragzone-juan-maestro",
    navbarLogo: "/gnbrands/navbar-juan-maestro.png",
    footer: [{
      ico: 'instagram',
      label: 'Juan Maestro CL',
      url: 'https://www.instagram.com/juan_maestro/'
    }, {
      ico: 'facebook',
      label: 'Juan Maestro CL',
      url: 'https://web.facebook.com/JuanMaestroChile/'
    }]
  }

  const barrioChicken = {
    name: "BARRIO_CHICKEN",
    imgSelector: "/gnbrands/gn-barrio-chicken.jpg",
    color: "#C6362E",
    cssUploadBanner: "custom-dragzone-barrio-chicken",
    navbarLogo: "/gnbrands/navbar-barrio-chicken-2.png",
    footer: [{
      ico: 'instagram',
      label: 'Barrio Chicken CL /',
      url: 'https://www.instagram.com/barriochickencl/'
    }, {
      label: 'Barrio Chicken MX',
      url: 'https://www.instagram.com/barriochickenmx/'
    }, {
      ico: 'facebook',
      label: 'Barrio Chicken CL /',
      url: 'https://web.facebook.com/barriochickencl/'
    }, {
      label: 'Barrio Chicken MX',
      url: 'https://www.facebook.com/BarrioChickenMX'
    }]
  }

  const doggies = {
    name: "DOGGIES",
    imgSelector: "/gnbrands/gn-doggies.jpg",
    color: "#F5D211",
    cssUploadBanner: "custom-dragzone-doggis",
    navbarLogo: "/gnbrands/navbar-doggis.png",
    footer: [{
      ico: 'instagram',
      label: 'Doggis CL /',
      url: 'https://www.instagram.com/doggischile/'
    }, {
      label: 'Doggis MX',
      url: 'https://www.instagram.com/doggis_mx/'
    }, {
      ico: 'facebook',
      label: 'Doggis CL /',
      url: 'https://web.facebook.com/DoggisChile/'
    }, {
      label: 'Doggis MX',
      url: 'https://web.facebook.com/DoggisMx/'
    }, {
      ico: 'tiktok',
      label: 'Doggis CL',
      url: 'https://www.tiktok.com/@tiodoggis'
    }]
  }

  const tommyBeans = {
    name: "TOMMY_BEANS",
    imgSelector: "/gnbrands/gn-tommy-beans.jpg",
    color: "#E6BC00",
    cssUploadBanner: "custom-dragzone-tommy",
    navbarLogo: "/gnbrands/navbar-tommy.png",
    footer: [{
      ico: 'instagram',
      label: 'Tommy Beans CL /',
      url: 'https://www.instagram.com/tommybeanschile/'
    }, {
      label: 'Tommy Beans MX',
      url: 'https://www.instagram.com/tommybeans_mx/'
    }, {
      ico: 'facebook',
      label: 'Tommy Beans CL /',
      url: 'https://web.facebook.com/TommyBeansChile/'
    }, {
      label: 'Tommy Beans MX',
      url: 'https://web.facebook.com/TommyBeansMX/'
    }]
  }

  console.log('REACT_APP_BUNKEY_ENV', process.env.REACT_APP_BUNKEY_ENV);
  if (process.env.REACT_APP_BUNKEY_ENV === "production") {
    return [{
      ...mamut,
      _id: "66a7b852d88500b33cab4d8e",
    }, {
      ...juanMaestro,
      _id: "66a7b8a2d88500b33cab4d96",
    }, {
      ...barrioChicken,
      _id: "66a265f2d88500b33cab4d83",
    }, {
      ...doggies,
      _id: "669963f9d88500b33cab4d60",
    }, {
      ...tommyBeans,
      _id: "669fb671d88500b33cab4d72"
    }]
  } else if (process.env.REACT_APP_BUNKEY_ENV === "qa") {
    return [{
      ...mamut,
      _id: "66ce63dfcbfe6810d7ada5cc",
    }, {
      ...juanMaestro,
      _id: "66ce63c1cbfe6810d7ada5c4",
    }, {
      ...barrioChicken,
      _id: "66ce6353cbfe6810d7ada5b4"
    }, {
      ...doggies,
      _id: "66ce6383cbfe6810d7ada5bc",
    }, {
      ...tommyBeans,
      _id: "66ce63fdcbfe6810d7ada5d4"
    }]
  } else {
    return [{
      ...mamut,
      _id: "66b8f0d7b809a311777b9f16",
    }, {
      ...juanMaestro,
      _id: "66b8f1f1b809a311777b9f1e",
    }, {
      ...barrioChicken,
      _id: "66b8f219b809a311777b9f26",
    }, {
      ...doggies,
      _id: "66b8f22fb809a311777b9f2e",
    }, {
      ...tommyBeans,
      _id: "66b8f24eb809a311777b9f36",
    }]
  }
}

export const startDownloadV2 = (workclient, files) => {
  // const url = 'http://localhost:3001/api/v1/download-jobs';
  

  let url = process.env.REACT_APP_BUNKEY_ENV === "production" ? 
    'https://bunkey-api.bunkey.tv/v1/downloads-services' : process.env.REACT_APP_BUNKEY_ENV === "qa" ? 
    'http://bunkey-api-qa.bunkey.tv/v1/downloads-services' : 
    'http://bunkey-api-dev.bunkey.tv/v1/downloads-services';

  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId: workclient, files }),
  })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then(data => {
      console.log('Download job started:', data);
      
      let statusUrl = process.env.REACT_APP_BUNKEY_ENV === "production" ? 
        'https://bunkey-api.bunkey.tv/v1/' : process.env.REACT_APP_BUNKEY_ENV === "qa" ? 
        'http://bunkey-api-qa.bunkey.tv/v1/' : 
        'http://bunkey-api-dev.bunkey.tv/v1/';

      statusUrl += data.statusUrl;

      // Poll status endpoint every 1s until complete
      return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
          fetch(statusUrl)
            .then(res => {
              if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
              return res.json();
            })
            .then(statusData => {
              console.log('Download status:', statusData);
              if (statusData.status === 'completed') {
                clearInterval(interval);
                const link = document.createElement('a');
                link.href = statusData.url;
                link.setAttribute('download', '');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(statusData);
              }
            })
            .catch(error => {
              clearInterval(interval);
              reject(error);
            });
        }, 5000);
      });
    })
    .catch(error => {
      console.error('Error starting download job:', error);
    });
}